//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { IBusinessObjectReferenceWidgetElement } from '../../WidgetElements/IBusinessObjectReferenceWidgetElement';
import { IPrivacyManagementDTO } from '../../../DTO/IPrivacyManagementDTO';
import { IExistsPrivacyPermitResponse } from './IExistsPrivacyPermitResponse';

//element.Name=PrivacyController result.Name=PrivacyController element.FullName=Digita.Tustena.UIApiControllers.UI.CRM.PrivacyController);
/** WebApiController: PrivacyController */
export class PrivacyController
{
	constructor (axios: AxiosInstance)
	{
		
		if (axios === null || axios === undefined) {
		    throw new Error('axios argument is required in PrivacyController constructor class, and cannot be empty or undefined');
		}
		this.axios = axios;
		
	}
	/** Name of axios $http interface */
	private axios: AxiosInstance;
	public GetStatusAvailablePrivacySetting(request: IBusinessObjectReferenceWidgetElement, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IPrivacyManagementDTO[]>
	{
		return (this.axios.post('Privacy/GetStatusAvailablePrivacySetting', request, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ExistsPermitToSendSingleMail(request: IBusinessObjectReferenceWidgetElement, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IExistsPrivacyPermitResponse>
	{
		return (this.axios.post('Privacy/ExistsPermitToSendSingleMail', request, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public ExistsPermitToContact(request: IBusinessObjectReferenceWidgetElement, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IExistsPrivacyPermitResponse>
	{
		return (this.axios.post('Privacy/ExistsPermitToContact', request, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public Echo(payload: any, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.post('Privacy/Echo', payload, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetSwagger(honorAcceptLanguageHeader: boolean = false, bestPracticeOnly: boolean = true, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Privacy/GetSwagger?&honorAcceptLanguageHeader='+honorAcceptLanguageHeader+'&bestPracticeOnly='+bestPracticeOnly, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
